var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "card-img-top img-fluid" }, [
        _c("img", {
          staticClass: " img-fluid",
          attrs: {
            src:
              this.data.cover === null
                ? "/images/cover.jpg"
                : this.data.cover.url,
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body p-0" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex mt-0 ml-1 mr-1 mb-0 pt-1 border-top align-items-center justify-content-start",
          },
          [
            _c("span", { staticClass: "h3" }, [
              _c("a", {
                staticStyle: { color: "inherit" },
                attrs: { href: "/zoom/" + this.data.zoom_id },
                domProps: { textContent: _vm._s(this.data.title) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ml-auto" }, [
              _c(
                "div",
                {
                  staticClass: "badge badge-pill bg-gradient-secondary",
                  staticStyle: { padding: "0.2rem 0.5rem" },
                },
                [
                  _c("i", { staticClass: "feather icon-video" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.__("meeting.title_singular")) +
                      "\n                    "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex ml-1 mr-1 mt-0" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("span", {
            staticClass: "h6 primary",
            domProps: { textContent: _vm._s(_vm.showDateTime) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pt-1 pl-1 pr-1 border-top" }, [
          _vm.collapse_body
            ? _c("div", {
                directives: [{ name: "linkified", rawName: "v-linkified" }],
                staticClass: "breakAll image-resize",
                domProps: { innerHTML: _vm._s(_vm.data.description) },
              })
            : _c("div", {
                directives: [{ name: "linkified", rawName: "v-linkified" }],
                ref: "textBox",
                class: _vm.class_body,
                domProps: { innerHTML: _vm._s(_vm.data.description) },
              }),
          _vm._v(" "),
          _vm.enable_read_more + " image-resize"
            ? _c("div", [
                _vm.collapse_body
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-link font-small-3 mt-05 mb-05 p-0",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.collapse_body = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                                 " +
                            _vm._s(_vm.__("globals.read_less")) +
                            " "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-up" }),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-link font-small-3 mt-05 mb-05 p-0",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.collapse_body = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                                 " +
                            _vm._s(_vm.__("globals.read_more")) +
                            " "
                        ),
                        _c("i", { staticClass: "fa fa-chevron-down" }),
                      ]
                    ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        this.data.event_price != null
          ? _c("div", { staticClass: "d-flex border-top" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex ml-05 mr-05  mb-0 pb-05 pt-05 align-items-center justify-content-start",
                },
                [
                  _c("span", { staticClass: "font-small-2 ml-05" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("globals.from")) +
                        " " +
                        _vm._s(
                          _vm._f("currency")(
                            this.data.event_price,
                            _vm.site_tax
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ml-auto p-1",
                  attrs: {
                    "data-toggle": "modal",
                    "data-target": "#registerModal",
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm btn-primary waves-effect waves-light",
                    },
                    [
                      _c("i", { staticClass: "fa fa-dollar" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("globals.buy_now")) +
                          "\n                            "
                      ),
                    ]
                  ),
                ]
              ),
            ])
          : _c(
              "div",
              {
                staticClass: "d-flex border-top",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#registerModal",
                },
              },
              [
                _c("div", { staticClass: "ml-auto p-1" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm btn-primary waves-effect waves-light",
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.__("webinar.form.buttons.register_now")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", { staticClass: "primary mr-05" }, [
      _c("i", { staticClass: "feather icon-calendar" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }